export enum TABLE {
  FAVORITES = "favorites",
  FILES = "files",
  LINKS = "links",
  PRODUCTS = "products",
  SESSIONS = "sessions",

}

export type Doc<T, Id = string> = T & { _id: Id };

export type Sorted<T> = {
  items: T[],
  byId: { [key: string]: T }
}
